// extracted by mini-css-extract-plugin
export default {"wrapper":"direct-link_wrapper__S1uSH","chatbot_wrapper":"direct-link_chatbot_wrapper__HVdaS","logo":"direct-link_logo__b8Dgf"};